// extracted by css-extract-rspack-plugin
export default {"Box":"table-header-module__Box__eSu2N","Box_1":"table-header-module__Box_1__qQZGN"};